/**
 * Diese Komponente bindet dann das jeweilige Modul ein, übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

import 'regenerator-runtime/runtime'
import React from 'react'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'
import { composeWithDevTools } from '@redux-devtools/extension'

import { PostingConfiguration } from '@professocial/professocialTypes/types'

// Posting
import ProfessocialPosting from '@professocial/professocialPosting/src/screens/ProfessocialPosting'
import { PostingScreen } from '@professocial/professocialPosting/src/shared/types/types'
import { postingRootReducer } from '@professocial/professocialPosting/src/store/postingRoot.reducer'
import { postingRootSagas } from '@professocial/professocialPosting/src/store/postingRoot.sagas'

// Posting
const sagaMiddleware = createSagaMiddleware()
const storePosting = createStore(
  postingRootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware),
  ),
)
sagaMiddleware.run(postingRootSagas)

interface IImportProfessocialNetworkContentProps {
  postingConfiguration?: PostingConfiguration,
  postingScreen: PostingScreen,
}

const ImportProfessocialPosting: React.FC<IImportProfessocialNetworkContentProps> = (props) => {
  return (
    <Provider store={storePosting}>
      <ProfessocialPosting postingConfiguration={props.postingConfiguration} postingScreen={props.postingScreen}/>
    </Provider>
  )
}
export default ImportProfessocialPosting
